// Pending-join storage on the web (P-JOIN-5): localStorage, shared by every tab of the browser so a
// code opened in one tab survives sign-up and confirmation in another.
export const pendingJoinStorage = {
  async get(key: string): Promise<string | null> {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  async set(key: string, value: string): Promise<boolean> {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch {
      // Losing a pending join only means the parent opens the link again.
      return false;
    }
  },
  async remove(key: string): Promise<void> {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // As above.
    }
  },
};
